import React, { FC } from 'react'
import { useForm } from 'react-hook-form'
import { Button, DrawerBody, DrawerFooter, DrawerHeader, Heading, Stack, Text } from '@chakra-ui/react'

import { SalaryFilter } from 'InstitutionalManagement/types'
import SalaryFilterForm from 'InstitutionalManagement/components/SalaryFilterForm'
import { useCustomFormSalarySelectionDrawerManager } from '../../contexts/CustomFormSalarySelectionDrawerManager/Provider'
import CustomFormFilterWarningAlert from '../../../../components/CustomFormFilterWarningAlert'

type Props = {
  onClose: () => void
}

const SearchSalaryOnCustomForm: FC<Props> = ({ onClose }) => {
  const { handleSubmit, register } = useForm<SalaryFilter>({ defaultValues: { name: '' } })

  const { setView, filter, setFilter, setLoadingSalaries } = useCustomFormSalarySelectionDrawerManager()

  function onSubmit(salaryFilter: SalaryFilter) {
    setFilter({ ...filter, ...salaryFilter })
    setLoadingSalaries(true)
    setView('SELECT_SALARY')
  }

  return (
    <>
      <DrawerHeader>
        <Text>Selecionar um salário</Text>
        <Heading color="primary">Pesquisar os salários</Heading>
      </DrawerHeader>

      <DrawerBody>
        <Stack spacing={4}>
          <CustomFormFilterWarningAlert />

          <SalaryFilterForm register={register} />
        </Stack>
      </DrawerBody>

      <DrawerFooter>
        <Button variant="outline" onClick={onClose}>
          Fechar
        </Button>

        <Button onClick={() => handleSubmit(onSubmit)()}>Buscar salário</Button>
      </DrawerFooter>
    </>
  )
}

export default SearchSalaryOnCustomForm
